const getters = {
  getContact: (state) => {
    return state.contact;
  },
};

export { getters };
